export const name = 'freeze';

export const Freeze = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.17871 5.72607L8.80871 6.72357"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M10.1437 2.91357L9.13867 6.54357"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M18.8063 18.2211L15.1763 17.2161"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M13.8411 21.0336L14.8461 17.4036"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M7.45874 3.92627L16.5637 19.9838"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M3.22119 14.8687L5.87619 12.1912"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M3.19873 9.16113L5.86873 11.8161"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M20.7861 9.10864L18.1311 11.7786"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M20.8086 14.8086L18.1311 12.1611"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M2.77124 12.0037L21.2287 11.9287"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M10.5938 21.1312L9.42383 17.5537"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M5.50854 18.5511L9.08605 17.3811"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M13.4661 2.86865L14.6361 6.44615"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M18.5511 5.44873L14.9736 6.61873"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M7.83374 20.2237L16.1812 3.76123"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
